// extracted by mini-css-extract-plugin
export default {"message":"index_message_gtTXL"};